import SvgIcon from "@mui/material/SvgIcon";

export const UsersIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.719 18.752L16.079 13.628C15.9883 12.9022 15.6355 12.2346 15.0871 11.7506C14.5387 11.2667 13.8324 10.9997 13.101 11H10.897C10.1659 11.0002 9.46004 11.2674 8.91204 11.7513C8.36405 12.2352 8.01162 12.9026 7.92096 13.628L7.27996 18.752C7.24478 19.0335 7.2699 19.3193 7.35364 19.5903C7.43738 19.8614 7.57783 20.1116 7.76567 20.3242C7.9535 20.5368 8.18442 20.707 8.44309 20.8235C8.70176 20.94 8.98226 21.0002 9.26596 21H14.734C15.0176 21.0001 15.298 20.9398 15.5565 20.8232C15.8151 20.7066 16.0459 20.5364 16.2336 20.3238C16.4213 20.1112 16.5617 19.8611 16.6454 19.5901C16.729 19.3191 16.7541 19.0334 16.719 18.752Z"
        stroke="#F2F2F2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7Z"
        stroke="#F2F2F2"
        strokeWidth="2"
      />
      <path
        d="M4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10Z"
        stroke="#F2F2F2"
        strokeWidth="2"
      />
      <path
        d="M20 10C21.1046 10 22 9.10457 22 8C22 6.89543 21.1046 6 20 6C18.8954 6 18 6.89543 18 8C18 9.10457 18.8954 10 20 10Z"
        stroke="#F2F2F2"
        strokeWidth="2"
      />
      <path
        d="M3.99996 13H3.69396C3.22053 12.9999 2.76242 13.1678 2.40114 13.4738C2.03986 13.7798 1.79884 14.204 1.72096 14.671L1.38796 16.671C1.34018 16.9575 1.35538 17.2511 1.43253 17.5311C1.50968 17.8112 1.64692 18.0711 1.83469 18.2928C2.02247 18.5144 2.25628 18.6925 2.51986 18.8146C2.78344 18.9368 3.07046 19 3.36096 19H6.99996M20 13H20.306C20.7794 12.9999 21.2375 13.1678 21.5988 13.4738C21.9601 13.7798 22.2011 14.204 22.279 14.671L22.612 16.671C22.6598 16.9575 22.6445 17.2511 22.5674 17.5311C22.4902 17.8112 22.353 18.0711 22.1652 18.2928C21.9775 18.5144 21.7437 18.6925 21.4801 18.8146C21.2165 18.9368 20.9295 19 20.639 19H17"
        stroke="#F2F2F2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);
